import { createStyles, makeStyles } from '@material-ui/core/styles'

export const centerContentOnMobile = makeStyles((theme) =>
  createStyles({
    root: {
      [theme.breakpoints.down('sm')]: {
        // justifyContent: 'center',
        // display: 'grid',
        position: 'relative',
        width: 'auto',
      },
    },
  }),
)
